export enum LIFESTYLE_COMMUNITIES {
  WATER_AND_BEACH_FRONT = "water-and-beach-front",
  FAMILY_FRIENDLY = "family-friendly",
  LUXURY_PROPERTIES = "luxury-properties",
  YOUNG_PROFESSIONALS = "young-professionals",
  BUDGET_FRIENDLY = "budget-friendly",
}
